import { IDataSource, CaptureContext } from '../../../../Assembler/dist/registry/iface/iDataSource.js';

/**
 * Generic capture-source resolver that reads a named field from a scenario's DynamicAction result.
 * Used by the ordered-scenario capture mechanism so the harness needs no app-specific field knowledge.
 *
 * Source form: "actionresult:<FieldName>" — e.g. "actionresult:UserId" captures the UserId an action
 * handler emitted into its result. Returns the last non-empty occurrence across action results.
 */
export class ActionResultDataSource extends IDataSource {
    get scheme(): string {
        return 'actionresult';
    }

    resolve(context: CaptureContext): string | null {
        const field = context.SourceArg;
        if (!field || field === '') {
            return null;
        }
        const actionDict = context.ActionResult;
        if (actionDict === null) {
            return null;
        }
        let found: string | null = null;
        for (const actionValue of actionDict.values()) {
            const obj = actionValue.asObject();
            if (!obj) {
                continue;
            }
            if (obj.containsKey(field)) {
                const value = obj.getString(field) || '';
                if (value !== '') {
                    found = value;
                }
            }
        }
        return found;
    }
}
